export const MODAL_IDS = {
    acceptBill: 'acceptBill',
    preApproveBill: 'preApproveBill',
    rejectBill: 'rejectBill',
    confirmPayment: 'confirmPayment',
    observeBill: 'observeBill',
    invoiceDetail: 'invoiceDetail',
    observationText: 'observationText',
    correctionBill: 'correctionBill',
    greView: 'greView',
    confirmDeleteFile: 'confirmDeleteFile',
    confirmDeleteInvoice: 'confirmDeleteInvoice',
    ocDetail: 'ocDetail',
    necDetail: 'necDetail',
    uploadDocument: 'uploadDocument',
    successUpload: 'successUpload',
    purchaseOrderSettings: 'purchaseOrderSettings',
    financingRequest: 'financingRequest',
    financingAccept: 'financingAccept',
    financingConfirm: 'financingConfirm',
    billAttachments: 'billAttachments',
};
